export const InvictusFaqList = [
    {
        targetId: '1',
        heading: 'Q. What is the eligibility for the Invictus Admission Test?',
        subheading: 'Class 8th to 12th students and 12th Appeared/Passed are eligible to appear for the Invictus Admission Test.',
        bulletpoints: [],
    },
    {
        targetId: '2',
        heading: 'Q. What is the syllabus for the test?',
        subheading: 'The syllabus is PCM for class 11th &amp;12th students and Science &amp; Mathematics of the previous class for other classes’ students.',
        bulletpoints: [],
    },
    {
        targetId: '3',
        heading: 'Q. What type of questions will the test have?',
        bulletpoints: [],
        subheading: 'The test will have Multiple Choice Questions (MCQs) in the following sections: IQ, Mathematics, Physics and Chemistry',
    },
    {
        targetId: '4',
        heading:
            'Q. Where will the test be conducted?',
        bulletpoints: [],
        subheading: 'The Invictus Admission Test will be conducted in pen-paper mode at select branches',
    },
    {
        targetId: '5',
        heading: 'Q. How can I get more information about the test?',
        bulletpoints: [],
        subheading: 'For more information, please call us at 7303759494 or email us at support.invictus@aesl.in',
    },
]